import { freeSet as icons } from '@coreui/icons'; // Load ALL Icons
import CoreuiVue from '@coreui/vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js';
import auth from '@websanova/vue-auth/dist/v2/vue-auth.esm.js';
import axios from 'axios';
import 'core-js/stable';
import Maska from 'maska';
import moment from 'moment';
import numeral from 'numeral';
import 'regenerator-runtime/runtime';
import { default as VCalendar, default as VDatePicker } from 'v-calendar';
import Vue from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css'; // Import the CSS or use your own!
import App from './App';
import calcTVA from './plugins/calc-tva';
import dataExporter from './plugins/data-exporter.js';
import { debounce } from './plugins/debounce';
import formDataToApi from './plugins/form-data-to-api.js';
import ghostlexly_cookies from './plugins/ghostlexly-cookies/ghostlexly-cookies';
import loadGoogleMaps from './plugins/load-google-maps-api';
import qz from './plugins/qz-tray';
import driverAuthBearer from './plugins/vue-jwt-auth-driver';
import router from './router';
import store from './store';

Vue.prototype.$google = loadGoogleMaps;

Vue.prototype.$debounce = debounce;

numeral.register('locale', 'fr', {
	delimiters: {
		thousands: ' ',
		decimal: ',',
	},
	abbreviations: {
		thousand: 'k',
		million: 'm',
		billion: 'b',
		trillion: 't',
	},
	ordinal: function (number) {
		return number === 1 ? 'er' : 'ème';
	},
	currency: {
		symbol: '€',
	},
});
numeral.locale('fr');

Vue.prototype.$numeral = numeral;

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
	componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(VDatePicker, {
	componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
});

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.prototype.$log = console.log.bind(console);

Vue.prototype.$calcTVA = calcTVA;

// --> axios import
Vue.prototype.$axios = axios;
Vue.prototype.$axios.interceptors.request.use(config => {
	if (config.method === 'patch') {
		config.headers['Content-Type'] = 'application/merge-patch+json';
	} else if (config.method === 'post') {
		config.headers['Content-Type'] = 'application/json';
	}

	return config;
});

// --> dataexporter import
Vue.prototype.$dataExporter = dataExporter;

// --> formdatatoapi import
Vue.prototype.$formDataToApi = formDataToApi;

// --> MomentJS import
moment.locale('fr');
Vue.prototype.$moment = moment;

// --> Font Awesome
library.add(fas);
Vue.component('fa-icon', FontAwesomeIcon);

// --> Notifications
Vue.use(Toast, {
	timeout: 6000,
});

// --> ZPL Printer (QZ Tray)
Vue.prototype.$qz = qz;

// --> Input mask
Vue.use(Maska);

// --> Cookies
Vue.prototype.$cookies = ghostlexly_cookies;

// --> Auth module
Vue.use(auth, {
	plugins: {
		http: axios,
		router: router,
	},
	drivers: {
		auth: driverAuthBearer,
		http: driverHttpAxios,
		router: driverRouterVueRouter,
	},
	options: {
		// --> Auth basic options
		tokenDefaultKey: 'auth_admin_token',
		rememberkey: 'auth_remember',
		stores: ['cookie'],
		rolesKey: 'role', // key name in the data() of the user's infos received with fetch()
		authRedirect: { name: 'Login' }, // if meta.auth is set to anything other than undefined or false.
		forbiddenRedirect: { name: 'Login' }, // if the user object's role property does not match up with the auth value.
		notFoundRedirect: { name: 'Page404' },
		// --> login options
		loginData: {
			url: '/api/login',
			method: 'POST',
			redirect: '/',
			fetchUser: true,
			staySignedIn: true,
		},
		logoutData: {
			url: 'auth/logout',
			method: 'POST',
			makeRequest: false,
			redirect: { name: 'Login' },
		},
		// --> fetch user data options
		fetchData: {
			url: '/api/me',
			method: 'GET',
			enabled: true,
		},
		// --> parse user data on fetch
		parseUserData(data) {
			return data || {};
		},
		// --> auto refresh the token
		refreshData: {
			url: '/api/token/refresh',
			method: 'GET',
			enabled: false,
			interval: 30,
		},
		// --> set cookies options
		cookie: {
			Path: '/adminghostlexly',
		},
	},
});
// 00===================================================================================================================

new Vue({
	el: '#app',
	router,
	store,
	icons,
	template: '<App/>',
	components: {
		App,
	},
});
